const axios = require('axios');

import { serverUrl, presighnedUrl } from '../properties';
const dataUrl = serverUrl;

export default {
	namespaced: true,
	state: {
		actionSelectionControl: false,
		selectedProducts: [],
		productAccendingOrder: false,
		productList: [],
		editSelectedProduct: {},
		currentSelectedProduct:{},
		currentTagProduct:{},
		productAdvanceFilter:{},
		deleteProdName:'',
		product_full_count:0,
		tagList:[],
		grouping:'Group'
	},
	mutations: {
		updateProductList: (state, data) => {
			console.log('test')
			if(data && data.length){
				state.product_full_count = data[0].full_count
			}
			else{
				state.product_full_count = 0;
			}
			state.productList = data.map((element) => {
				element.isSelected = false
				return element
			})
		},
		updateProductTagLabels: (state, data) => {
			state.tagList = state.tagList.map((l) => {
				l.label = data.find(tag => tag.type == l.value).name
			})
		},
		addNewProductToList: (state, data) => {
			state.productList.unshift(data)
		},
		setadvanceFilterProduct: (state, data) => {
			state.productAdvanceFilter = data
		},
		sortProductList: (state, data) => {
			if (state.productAccendingOrder) {
				state.productList.sort((a, b) => {
					return a.totalCampaign - b.totalCampaign
				})
			}
			else {
				state.productList.sort((a, b) => {
					return b.totalCampaign - a.totalCampaign
				})
			}
		},
		setSelectedProduct:(state, data) => {
			 state.selectedProducts = data;
		},
		setActionSelectionControl:(state, data) => {
			state.actionSelectionControl = data
		},
		updateCurrentSelectedProduct:(state, data) => {
			state.currentSelectedProduct = data
		},
		updateCurrentTagProduct:(state, data) => {
			console.log('SETTING_TAG_PRODUCT: ' + JSON.stringify(data))
			state.currentTagProduct = data
		},
	},
	getters: {
	},
	actions: {
		addNewProduct: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {

				payload.data.userName = JSON.parse(window.localStorage.session).name
				payload.data.entityType = state.currentTagProduct.entity_type
				commit('showLoadingSpinner', null, { root: true })
				axios({
					//uri:serverUrl + '/product/add',
					url: dataUrl + '/product/add',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload.data,
					responseType: 'json'
				}).then((response) => {
					commit('hideLoadingSpinner', null, { root: true })
					resolve(response)
					if(payload.data.vendor_id && payload.data.isUpdateVendorForHeader){
					  commit('setSelectedVendorProduct',payload.data.vendor_id,{root : true})
					}
					if(payload.data.brand_id){
					  commit('setSelectedBrandProduct',payload.data.brand_id,{root : true})
					}
				}).catch((error) => {
					commit('hideLoadingSpinner', null, { root: true })
					reject(error);
				})
			})
		},
		getAllProducts: ({ commit, state, rootGetters, rootState }, data) => {
			return new Promise((resolve, reject) => {

				let pagination = {
					"pageNumber": rootGetters.getCurrentPageNumber - 1,//0,
					"showPerPage": sessionStorage.getItem("products:showPerPage"),
					//"sort": rootGetters.getSelectedSortOrder
				}
				var payload = {}
				var showLoadingSpinner = true;
				if (data) {
					if(data.id){
						payload = {
							id: data.id,
							brand: true,
							sort: rootState.selectedSortOrder,
							ams_profile_id: data.ams_profile_id,
						}
					}
					else if(data.q){
						payload = {
							q:data.q ,
							ams_profile_id: "",
							campaign_group_id: "",
							vendor: "",
							pagination: {pageNumber: 0, showPerPage: null},
							sort: {
								field:"product_title",
								order:"asc"
							}
						}

					}

					showLoadingSpinner = data.doNotShowSpinner ? !data.doNotShowSpinner : !data.hideLoadingSpinner;
				}
				else {
					payload = {
						q: rootState.searchFilterString,
						ams_profile_id: rootState.selectedBrandProduct,
						campaign_group_id: rootGetters.getSelectedCampaignGroupFilter,
						vendor: rootState.selectedVendorProduct,
						pagination: pagination,
						sort: rootState.selectedSortOrder
					}
				}

				if(data && data.isWithoutPagination){
					payload =  data
				}

				payload.category =  (state.productAdvanceFilter && state.productAdvanceFilter.hasOwnProperty('category') ? state.productAdvanceFilter.category : null)
				payload.style =  (state.productAdvanceFilter && state.productAdvanceFilter.hasOwnProperty('style') ? state.productAdvanceFilter.style : null)
				payload.partneruuid = payload.vendor ? rootState.selectedVendorPartnerUuid : ''
				payload.isSeller = rootState.isSeller
				console.log('FILTER',rootState.isFilter)
				payload.isFilter = rootState.isFilter
				payload.tags = rootState.tagFilterOptions

				if( showLoadingSpinner ){
					commit('showLoadingSpinner', null, {
						root: true
					})
				}
				if (showLoadingSpinner) {
					commit('showLoadingSpinner', null, { root: true });
				}
				axios({
					url: dataUrl + '/product/list',
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {

					if(response.data && response.data.data){
						if(data && data.isWithoutPagination){
						}
						else{
							commit('updateProductList', response.data.data)
						}
						if(response.data && response.data.productcount!=undefined){
							commit('updateTotalCampaignAndProductCount',response.data.productcount, {
								root: true
							})
						}
					}
					else{
						if(data && data.isWithoutPagination){
						}
						else{
							commit('updateProductList', response.data)
						}
					}
					commit('setSelectedProduct',[])
					commit('setActionSelectionControl', false)
					commit('hideLoadingSpinner', null, { root: true })
					resolve(response.data.data)
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		getAllProductsForExport: ({ commit, state, rootGetters, rootState }, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				payload.partneruuid = payload.vendor ? rootState.selectedVendorPartnerUuid : ''
				commit('showLoadingSpinner', null, { root: true });
				axios({
					url: dataUrl + '/product/export',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					commit('hideLoadingSpinner', null, { root: true })
					resolve(response)
				}).catch((error) => {
					commit('hideLoadingSpinner', null, { root: true })
				})
			})

		},
		deleteProduct: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {
				commit('showLoadingSpinner', null, { root: true });
				let data = {
					id: payload.data.productId,
					type : 'single'
				}
				axios({
					//    uri: serverUrl + '/deleteProduct/' + payload.data.productId,
					url: dataUrl + '/product/del',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: data,
					responseType: 'json'
				}).then((response) => {
					resolve(response)
				}).catch((error) => {
					commit('hideLoadingSpinner', null, { root: true })
				})
			})

		},
		deleteMultipleProducts: ({ commit, state, rootGetters }, payload) => {
			commit('showLoadingSpinner', null, { root: true });
			payload.data.type = "multiple";
			axios({
				url: dataUrl + '/product/del',
				method: 'POST',
				headers: rootGetters.fetchHeader,
				data:payload.data,
			}).then((response) => {
				if (payload.callback) {
					payload.callback()
				}
			}).catch((error) => {
				commit('hideLoadingSpinner', null, { root: true })
			})
		},
		getProductById: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {
				commit('showLoadingSpinner', null, { root: true });
				axios({
					url: dataUrl + '/product/get',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						//	payload.callback(response.data)
						resolve(response.data)
						commit('hideLoadingSpinner', null, { root: true })
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		getProductsForId: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {
				commit('showLoadingSpinner', null, { root: true });
				axios({
					url: dataUrl + '/product/get',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						//	payload.callback(response.data)
						resolve(response.data)
						commit('hideLoadingSpinner', null, { root: true })
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		getAllProductsForScope: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {

				axios({
					url: dataUrl + '/product/getScope',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						//	payload.callback(response.data)
						resolve(response.data)
					//	commit('hideLoadingSpinner', null, { root: true })
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		getTagsForProduct: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {
				if(!payload) {
					payload = {
						asin : state.currentTagProduct.asin,
						id : state.currentTagProduct.id,
						entityType : state.currentTagProduct.entity_type
					}
					console.log('TAG_LIST_PAYLOAD: ', JSON.stringify(payload))
				}
				
				axios({
					url: dataUrl + '/product/getTags',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						console.log('TAG_RESPONSE',payload,response.data.tags)
						state.tagList = response.data.tags
						resolve(response.data)
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		addTags: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;


				axios({
					url: dataUrl + '/product/addTags',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data)
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		getTagsInfo: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {

				axios({
					url: dataUrl + '/product/getTagsInfo',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data)
						commit("updateCurrentSelectedProduct", response.data)
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		deleteProductTag: ({ commit, state, rootGetters }, payload) => {
			return new Promise((resolve, reject) => {

				payload.entityType = state.currentTagProduct.entity_type
				axios({
					url: dataUrl + '/product/deleteTag',
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					if (response.data) {
						resolve(response.data)
					}
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root: true })
				})
			})
		},
		getPresighnedURL({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload){
			return new Promise((resolve, reject) => {
				let url = presighnedUrl;
				let data = {
					"contentType": "text/csv",
					"ext": "csv"
				}
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: data,
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		uploadFile({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload){
			return new Promise((resolve, reject) => {

				let headers = {};
				

				axios({
					url: payload.url,
					method: 'PUT',
					data: payload.data,
					//for csv
					headers: {'Content-Type': 'text/csv'},
					//for excel
					// headers: {"Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
					}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		updateFileData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload){
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;

				//	let url = dataUrl + "/account/updateBulkData";
				let url = dataUrl + "/product/uploadData";

				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
	}
}
